import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1 6.843c-.6 0-1 .391-1 .978 0 .586.4.977 1 .977 4.4 0 8 3.52 8 7.82 0 .587.4.978 1 .978s1-.39 1-.977c0-5.377-4.5-9.776-10-9.776M1 0C.4 0 0 .39 0 .977s.4.978 1 .978c8.3 0 15 6.55 15 14.664 0 .586.4.977 1 .977s1-.39 1-.977C18 7.429 10.4 0 1 0m3 15.641c0 1.08-.895 1.955-2 1.955s-2-.875-2-1.955.895-1.955 2-1.955 2 .875 2 1.955"
    }, null, -1)
  ]))]))
}
export default { render: render }